function applyPasswordVisible() {
    //visibility password
    const passwordInput = document.getElementById('customer-password');
    const passwordDisplay = document.getElementById('icon-password-display');
    const passwordHidden = document.getElementById('icon-password-hidden');

    if (passwordInput && passwordDisplay && passwordHidden) {
        // Adicionar evento de clique ao ícone de exibição da senha
        passwordDisplay.addEventListener('click', function () {
            // Trocar classes para alterar a exibição do ícone
            passwordDisplay.classList.add('d-none');
            passwordHidden.classList.remove('d-none');
            passwordInput.type = 'text';

        });

        // Adicionar evento de clique ao ícone de senha oculta
        passwordHidden.addEventListener('click', function () {
            // Trocar classes para alterar a exibição do ícone
            passwordHidden.classList.add('d-none');
            passwordDisplay.classList.remove('d-none');
            passwordInput.type = 'password';
        });
    }
}

function regexEmail(email) {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

function validateEmail(){

    if(this.value != '') {
        if(regexEmail(this.value)){
            this.classList.remove("errors");
            document.getElementById('error1').style.display = 'none';
            enableButton();
        } else {
            this.classList.add("errors");
            document.getElementById('error1').style.display = 'inline-block';
            document.getElementById('error1').textContent = "Formato de e-mail inválido";
            enableButton();
        }

    } else {
        this.classList.add("errors");
        document.getElementById('error1').style.display = 'inline-block';
        document.getElementById('error1').textContent = "Campo obrigatório";
        enableButton();
    }    
}

function validateEmailFieldAutocomplete(field){

    if(field.value != '') {
        if(regexEmail(field.value)){
            field.classList.remove("errors");
            document.getElementById('error1').style.display = 'none';
            enableButton();
        } else {
            field.classList.add("errors");
            document.getElementById('error1').style.display = 'inline-block';
            document.getElementById('error1').textContent = "Formato de e-mail inválido";
            enableButton();
        }

    }
}

function validatePass(){

    if(this.value != '') {
        this.classList.remove("errors");
        document.getElementById('error2').style.display = 'none';
        enableButton();
    } else {
        this.classList.add("errors");
        document.getElementById('error2').style.display = 'inline-block';
        enableButton();
    }
}

function validatePassFieldAutocomplete(field){

    if(field.value != '') {
        field.classList.remove("errors");
        document.getElementById('error2').style.display = 'none';
        enableButton();
    }
}

function enableButton(){
    mail = document.getElementById('customer-email');
    pass = document.getElementById('customer-password');

    if(!mail.classList.contains('errors') && !pass.classList.contains('errors')) {
        button = document.getElementById('button-send');
        button.classList.add('active');
        button.removeAttribute('disabled', 'disabled');
    } else {
        button = document.getElementById('button-send');
        button.classList.remove('active');
        button.setAttribute('disabled', 'disabled');
    }
}


function getParamFromURL(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

window.onload = function(event) {

    const mail = document.getElementById('customer-email');
    mail.addEventListener('focusout', validateEmail);

    const pass = document.getElementById('customer-password');
    pass.addEventListener('focusout', validatePass);

    mail.addEventListener('change', validateEmail);
    pass.addEventListener('change', validatePass);

    validateEmailFieldAutocomplete(mail);
    validatePassFieldAutocomplete(pass);
  
    var returnToValue = getParamFromURL('return_to');

    if (returnToValue) {
        var returnToInput = document.getElementById('returnToInput');
        returnToInput.value = returnToValue;

        var regbtn = document.getElementById('register-btn');
        regbtn.setAttribute('href', '/account/register?return_to=' + returnToValue);
    }

    applyPasswordVisible();

};